module.exports = __webpack_public_path__ + "static/media/slammers-fc.186d9d7a.svg";